import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
// import LogRocket from 'logrocket'
import queryString from 'query-string'
import type { NfdBrowseParams } from 'api/api-client'
import axios from 'axios'
import { CustomError } from 'api/customError'

export const AXIOS_INSTANCE = Axios.create({
  baseURL: process.env.NEXT_PUBLIC_API as string
})

export const customAxios = async <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<T>> => {
  // let recordingURL = ''

  // LogRocket.getSessionURL(function (sessionURL) {
  //   recordingURL = sessionURL
  // })

  const axiosConfig = {
    ...config,
    ...options,
    headers: {
      ...config.headers,
      ...options?.headers
      // 'X-LogRocket-URL': recordingURL
    },
    paramsSerializer: (params: NfdBrowseParams) => queryString.stringify(params)
  }

  const promise = AXIOS_INSTANCE(axiosConfig)
    .then((res) => res)
    .catch((error) => {
      if (axios.isAxiosError(error)) {
        throw new CustomError(
          error?.response?.data.message,
          error?.response?.data.name,
          error?.response?.status,
          error
        )
      }

      throw new CustomError(error?.message, error?.name, error?.statusCode, error)
    })

  return promise
}
